import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "pc",
})
export class PercentagePipe implements PipeTransform {
	transform(value: number, pc: number): number {
		if (isNaN(value) || isNaN(pc) || pc === 0) {
			return 0;
		}
		return value * (pc / 100);
	}
}
